import { i18n } from '@lingui/core';

export const ROUTE_PATH = '/admin/notifications';
export const TITLE = i18n._('Notifications');
